import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
/**
 * Transport for the coalescing batcher behind useSpaceIconQuery. Unknown ids
 * are omitted from the response by contract; the caller owns seeding the
 * per-icon cache entries.
 */
export const batchGetSpaceIcons = async ({ client, reason }, { ids }) => {
    const { data, error, response } = await client.POST('/rest/spaces/icon', reason, {
        body: { ids },
        timeoutMs: getQueryTimeoutMs(),
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to fetch space icons batch',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
};
//# sourceMappingURL=batchGetSpaceIcons.js.map